/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { rastreamentosModuleName } from "../shared/data.service";
import { configuracaoModuleName } from "../../shared/services/data.service";
import {ModeloGpsNavigationService} from "../modelos-gps/shared/modelo-gps-navigation.service";
import {modeloGpsModuleName} from "../modelos-gps/shared/data.service";
import {cercaModuleName} from "../cercas/shared/data.service";
import {CercaNavigationService} from "../cercas/shared/cerca-navigation.service";
import {alarmeModuleName} from "../alarmes/shared/data.service";
import {AlarmeNavigationService} from "../alarmes/shared/alarme-navigation.service";

@Component({
    template: require('./rastreamento-configuracao.component.html'),
    styles: [require('./rastreamento-configuracao.component.css')]
})
export class RastreamentoConfiguracaoComponent implements OnInit {
    module: any = rastreamentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    modeloGpsModule: any = modeloGpsModuleName;
    cercaModule: any = cercaModuleName;
    alarmeModule: any = alarmeModuleName;

    constructor(
        private _modeloGpsNavigationService: ModeloGpsNavigationService,
        private _cercaNavigationService: CercaNavigationService,
        private _alarmeNavigationService: AlarmeNavigationService
    ) { }

    ngOnInit() {
    }

    clickItem(module: any) {
        if (module.plural === this.modeloGpsModule.plural) {
            this._modeloGpsNavigationService.goToList();
        } else if (module.plural === this.cercaModule.plural) {
            this._cercaNavigationService.goToList();
        } else if (module.plural === this.alarmeModule.plural) {
            this._alarmeNavigationService.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/configuracao/rastreamento-configuracao.component.ts
 **/